var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('el-container',{staticStyle:{"height":"100%"}},[(_vm.headerType==1)?_c('el-header',[_c('top')],1):_vm._e(),_c('div',{staticClass:"router_container"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }